import{getDefaultExportFromCjs as r}from"../../_virtual/_commonjsHelpers.js";import{_ as o}from"./_createCompounder.js";var e=r(o((function(r,o,e){return r+(e?"-":"")+o.toLowerCase()})));export{e as default};
//# sourceMappingURL=kebabCase.js.map
